<template>
  <section ref="textintro" class="relative introslide flex min-h-screen bg-workbook-white">
    <UContainer class="thisbloodycontainer flex flex-col min-h-screen px-4 lg:px-0">
      <UPageGrid class="toprow gap-0 border-x-2 border-workbook-light-grey flex-1 border-b-2">
        <div class="col-span-6 lg:border-r-2 border-workbook-light-grey min-h-20"></div>
        <div class="hidden lg:blockcol-span-3 border-r-2 border-workbook-light-grey"></div>
        <div class="hidden lg:blockcol-span-3"></div>
      </UPageGrid>
      <UPageGrid class="gap-0 border-b-2 border-x-2 border-workbook-light-grey">
        <div class="col-span-6 lg:border-r-2 border-workbook-light-grey flex items-center p-8">
          <h1 class="mb-0 font-normal">A common reality</h1>
        </div>
        <div class="hidden lg:block col-span-3 border-r-2 border-workbook-light-grey"></div>
        <div class="hidden lg:block col-span-3"></div>
      </UPageGrid>
      <UPageGrid class="gap-0 border-b-2 border-x-2 border-workbook-light-grey">
        <div class="col-span-6 lg:border-r-2 border-workbook-light-grey flex items-center p-8">
          <p class="mb-0">
            Sell-in is often built around spreadsheets, PDFs or heavy and expensive platforms.
          </p>
        </div>
        <div class="hidden lg:block col-span-3 border-r-2 border-workbook-light-grey"></div>
        <div class="hidden lg:block col-span-3 bg-workbook-dark-grey/15"></div>
      </UPageGrid>
      <UPageGrid class="gap-0 border-b-2 border-x-2 border-workbook-light-grey">
        <div class="col-span-6 lg:border-r-2 border-workbook-light-grey flex items-center">
          <p class="mb-0 p-8">
            Sales tools and catalogs are functional, but not visually appealing.
          </p>
        </div>
        <div class="hidden lg:block col-span-3 border-r-2 border-workbook-light-grey bg-workbook-dark-grey/15"></div>
        <div class="hidden lg:block col-span-3"></div>
      </UPageGrid>
      <UPageGrid class="gap-0 border-b-2 border-x-2 border-workbook-light-grey">
        <div class="col-span-6 lg:border-r-2 border-workbook-light-grey flex items-center">
          <p class="mb-0 p-8">
            The result works.
          </p>
        </div>
        <div class="hidden lg:block col-span-3 border-r-2 border-workbook-light-grey"></div>
        <div class="hidden lg:block col-span-3"></div>
      </UPageGrid>
      <UPageGrid class="gap-0 border-b-2 border-x-2 border-workbook-light-grey">
        <div class="col-span-6 lg:border-r-2 border-workbook-light-grey flex items-center">
          <p class="mb-0 p-8 font-semibold">
            But it’s far from inspiring. And it costs time across sales and operations.
          </p>
        </div>
        <div class="hidden lg:block col-span-3 border-r-2 border-workbook-light-grey"></div>
        <div class="col-span-3 bg-workbook-dark-grey/15"></div>
      </UPageGrid>
      <UPageGrid class="bottomrow gap-0 border-x-2 border-workbook-light-grey flex-1 min-h-20">
        <div class="col-span-6 lg:border-r-2 border-workbook-light-grey"></div>
        <div class="hidden lg:blockcol-span-3 border-r-2 border-workbook-light-grey"></div>
        <div class="hidden lg:blockcol-span-3"></div>
      </UPageGrid>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

import { loadGsap } from '@/utils/gsap'

const textintro = ref<HTMLElement | null>(null)
let ctx: gsap.Context | null = null

onMounted(async () => {
  if (!process.client) return

  const { gsap } = await loadGsap()

  const h1 = textintro.value?.querySelector('h1')
  const pElements = textintro.value?.querySelectorAll('p') || []

  if (h1 && pElements.length > 0 && textintro.value) {
    ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: textintro.value,
          pin: false,
          markers: false,
          start: 'top 45%',
          end: 'top 10%',
          scrub: 2,
          snap: {
            snapTo: 'labels',
            duration: { min: 0.2, max: 3 },
            delay: 0.2
          }
        }
      })
      tl.fromTo(h1, { opacity: 0 }, { opacity: 1, duration: 3 })
      tl.fromTo(pElements, { opacity: 0 }, { opacity: 1, duration: 3, stagger: 3 })
      tl.addLabel('midpoint')
    }, textintro.value || undefined)
  }
})

onUnmounted(() => {
  ctx?.revert()
  ctx = null
})
</script>

<style scoped>
@reference "../../assets/css/main.css";

p {
  @apply text-xl lg:text-2xl;
}
</style>
